import { AUTH_MOCK, GOOGLE_GSI_SRC } from './config';
import type { GoogleAccounts } from './types';

let loader: Promise<GoogleAccounts> | null = null;

/** Carrega (uma única vez) o SDK do Google Identity Services. */
export function loadGoogleIdentity(): Promise<GoogleAccounts> {
  /*
   * Em desenvolvimento o SDK inteiro é substituído pelo mock — nem o script do
   * Google chega a ser baixado.
   *
   * O `import.meta.env.DEV` repetido não é redundância: escrito literalmente
   * *neste* módulo, o Vite o troca por `false` antes do bundling e o `import()`
   * some junto com o ramo. Com a constante importada o ramo também morre, mas
   * o chunk do mock ainda vai parar em `dist/assets` — código que ninguém
   * importa, servido junto com o app. Assim `dist/` não tem nem o arquivo.
   */
  if (import.meta.env.DEV && AUTH_MOCK) {
    loader ??= import('./mock').then(({ createMockAccounts }) => createMockAccounts());
    return loader;
  }

  if (window.google?.accounts) return Promise.resolve(window.google.accounts);
  if (loader) return loader;

  loader = new Promise<GoogleAccounts>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${GOOGLE_GSI_SRC}"]`
    );
    const script = existing ?? document.createElement('script');

    const onLoad = () => {
      if (window.google?.accounts) resolve(window.google.accounts);
      else reject(new Error('SDK do Google carregou sem expor accounts.oauth2.'));
    };

    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener(
      'error',
      () => {
        loader = null;
        reject(new Error('Não foi possível carregar o SDK do Google.'));
      },
      { once: true }
    );

    if (!existing) {
      script.src = GOOGLE_GSI_SRC;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });

  return loader;
}
